import React from 'react'

export const IncomeDashboard = () => {
  return (
    <div> <div className="page-header">
    <div>
        <h2 className="main-content-title tx-24 mg-b-5"> Income and Expenses</h2>
        <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Income and Expenses</a></li>
            <li className="breadcrumb-item active" aria-current="page">Income and Expenses</li>
        </ol>
    </div>
</div></div>
  )
}
